export const config = {
  PartnersIntro: {
    title: 'Select a Stylist',
    description: 'Our Home Design Stylists have expertise in all areas of interior design. Get advice on the latest trends, products, and colours that work for your space.',
  },
};
